// extracted by mini-css-extract-plugin
export default {"action":"BoardActions_action__4ShVr","actions":"BoardActions_actions__jF5z+","wrapper":"BoardActions_wrapper__rxxRn"};